import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useApi } from "../../../hooks";
import { Button, ButtonGroup } from "../../Form";
import { assetShape, documentsShape, nodeShape } from "../../../shapes";
import {
  addSortedSuccessorCategories,
  getDocumentLanguages,
} from "../../../utils";
import AllOrMultipleSelect from "../../AllOrMultipleSelect";

type Props = {
  stepsState: {
    categoriesSelectionStep?: {
      selectedSwitch?: string;
      selectedItems?: {
        id: string | number;
        name: string;
        code: string;
      }[];
    };
    languagesSelectionStep?: {
      selectedSwitch?: string;
      selectedItems?: {
        id: string | number;
        name: string;
        code: string;
      }[];
    };
  };
  setStepsState: $TSFixMeFunction;
  onClose: $TSFixMeFunction;
  handleNext?: $TSFixMeFunction;
  includedDocuments?: documentsShape;
  object:
    | {
        asset?: assetShape;
      }
    | {
        node?: nodeShape;
      };
};

function CategoriesSelectionStep({
  setStepsState,
  stepsState,
  onClose,
  handleNext,
  includedDocuments = [],
  object,
}: Props) {
  const api = useApi();
  const intl = useIntl();
  const { data: documentCategories } = api.getAll.useQuery(
    "/document/categories",
    { include: "tenant" },
  );
  // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
  let categories = documentCategories?.categories
    ? // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
      [...documentCategories.categories]
    : undefined;
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  if (categories?.length > 0 && includedDocuments?.length > 0) {
    categories = addSortedSuccessorCategories(
      categories,
      includedDocuments,
      intl.formatMessage({ id: "export_files_dialog.no_categories" }),
    );
  }

  const handleSelectionSwitch = (value: $TSFixMe) =>
    setStepsState({
      ...stepsState,
      categoriesSelectionStep: {
        ...stepsState.categoriesSelectionStep,
        selectedSwitch: value,
      },
    });

  const handleSpecificSelectionChange = (newSelectedItems: $TSFixMe) => {
    const languages = getDocumentLanguages(
      includedDocuments.length ? includedDocuments : categories,
      newSelectedItems,
    );
    setStepsState((prevState: $TSFixMe) => ({
      ...prevState,
      categoriesSelectionStep: {
        ...stepsState.categoriesSelectionStep,
        selectedItems: newSelectedItems,
      },
      languagesSelectionStep: {
        ...stepsState.languagesSelectionStep,
        ...((object as $TSFixMe).asset && {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          selectedItems: stepsState.languagesSelectionStep.selectedItems.filter(
            (lang) => languages.includes(lang.id),
          ),
        }),
      },
    }));
  };

  return (
    <>
      <Modal.Body>
        <AllOrMultipleSelect
          title={intl.formatMessage({
            id: "export_files_dialog.file_categories.title",
          })}
          itemKey="categories"
          allItems={categories}
          handleSpecificSelectionChange={handleSpecificSelectionChange}
          handleSelectionSwitch={handleSelectionSwitch}
          // @ts-expect-error TS(2322) FIXME: Type '{ selectedSwitch?: string | undefined; selec... Remove this comment to see the full error message
          values={stepsState.categoriesSelectionStep}
          withTreeView
          includeNoItems={includedDocuments.length === 0}
        />
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            text={intl.formatMessage({ id: "button.close" })}
            onClick={onClose}
          />
          <Button
            hero
            text={intl.formatMessage({ id: "button.next" })}
            // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
            onClick={handleNext}
            disabled={
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              stepsState.categoriesSelectionStep.selectedItems.length === 0 &&
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              stepsState.categoriesSelectionStep.selectedSwitch ===
                "specific_selection"
            }
          />
        </ButtonGroup>
      </Modal.Footer>
    </>
  );
}

export default CategoriesSelectionStep;
